import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-vpp-pre-register",
	templateUrl: "./vpp-pre-register.component.html",
	styleUrls: ["./vpp-pre-register.component.css"],
})
export class VppPreRegisterComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
